import { createFileRoute } from '@tanstack/react-router';

import { routeMetadata } from '@/app/lib/tanstack-router';
import ChangeNamePage from '@/settings/pages/change-name';

export const Route = createFileRoute('/settings/_layout/user-profile/change-name')({
  head: () => ({
    meta: routeMetadata('Change Name')
  }),
  component: ChangeNameRoute,
  staticData: {
    headerSection: null
  }
});

function ChangeNameRoute() {
  return <ChangeNamePage/>;
}
